import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";
import RecipeSummaryCardImage from "../components/RecipeSummaryCardImage";

export default function MealPlanPage() {
  const { id } = useParams();
  const [mealPlan, setMealPlan] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    apiClient
      .get(`/mealplans/${id}`)
      .then((res) => setMealPlan(res.data));
  }, [id]);

  if (!mealPlan) return <p className="text-center mt-10">Loading meal plan...</p>;

  return (
    <div className="max-w-3xl mx-auto px-4 mt-10 space-y-6">
      {/* Title + Delete Plan Button */}
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">The {mealPlan.name} Mealplan</h1>
        <button
          onClick={() => navigate(`/edit/mealplan/${id}`)}
          className="text-grey-400 text-sm px-3 py-1 rounded-3xl hover:bg-gray-200"
        >
          Edit
        </button>
      </div>

      {/* Actions */}
      <div className="flex gap-4 mt-4">
        <button
          onClick={() => navigate(`/shopping/mealplan/${id}`)}
          className="flex-1 bg-sage text-white text-sm px-3 py-1 rounded-3xl hover:bg-sagedark"
        >
          Ingredient list
        </button>

        <button
          onClick={() => navigate(`/cook/mealplan/${id}`)}
          className="flex-1 border border-sage text-sage text-sm px-3 py-1 rounded-3xl hover:bg-sage/20"
        >
          Cook the {mealPlan.name} mealplan
        </button>
      </div>

      {/* Recipes */}
      {mealPlan.recipes.map((recipe, i) => (
      <RecipeSummaryCardImage key={i} recipe={recipe} index={recipe._id} />
      ))}
      {/*}
      {mealPlan.recipes.map((recipe) => (
        <div
          key={recipe._id}
          className="border rounded p-4 bg-white shadow space-y-2"
        >
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold">{recipe.name}</h2>
          </div>
          <p className="text-sm text-gray-600 italic">{recipe.summary}</p>
          <p className="text-sm text-gray-600">
            Prep: {recipe.prepTime} | Cook: {recipe.cookTime} | Serves: {recipe.servings}
          </p>
          <button
            onClick={() => navigate(`/cook/${recipe._id}`)}
            className="bg-sage w-full text-white text-sm px-3 py-1 rounded"
          >
            Cook It
          </button>
        </div>
      ))}*/}
    </div>
  );
}
